import { createStore, createEvent } from "effector";
import { Customer } from "../../types/customers.types";
import { customersStoreState } from "./CustomersStore.consts";
import { CustomersStoreState } from "./CustomersStore.types";
import { addCustomerEffect, deleteCustomerEffect, editCustomerEffect, getCustomersEffect, getWashingTypesEffect } from "./CustomersStore.effects";
import { WashingType } from "../../types/washingTypes.types";

// Eventos (ações)
export const setCustomers = createEvent<Customer[]>('setCustomers');
export const resetCustomersStore = createEvent();

// Store inicial
export const CustomersStore = createStore<CustomersStoreState>(customersStoreState)
  .on(setCustomers, (store, options) => ({
    ...store,
    vacuumOptions: options
  }))
  .on(getWashingTypesEffect.doneData, (store, washingTypes: WashingType[]) => ({
    ...store,
    washingTypes
  }))
  .on(getCustomersEffect.doneData, (store, customers: Customer[]) => ({
    ...store,
    customers
  }))
  .on(addCustomerEffect.doneData, (store, newCustomer: Customer) => {

    return ({
    ...store,
    customers: [...store.customers, newCustomer]
  })})
  .on(editCustomerEffect.doneData, (store, editedCustomer: Customer) => {
    const customers = store.customers.map(customer => customer.id === editedCustomer.id ? editedCustomer : customer);

    return ({
    ...store,
    customers
  })})
  .on(deleteCustomerEffect.doneData, (store, customerId: string) => {
    const customers = store.customers.filter(customer => customer.id !== customerId);

    return ({
    ...store,
    customers
  })})
  .reset(resetCustomersStore);
